export enum DaysOfWeekEnum {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6
}

export const DaysOfWeekOptions = [
{ id: 0, label: 'Sunday' },
{ id: 1, label: 'Monday' },
{ id: 2, label: 'Tuesday' },
{ id: 3, label: 'Wednesday' },
{ id: 4, label: 'Thursday' },
{ id: 5, label: 'Friday' },
{ id: 6, label: 'Saturday' }
];
